import React, {useEffect} from "react";
import { useParams } from "react-router-dom";
import { sellers } from "../Data";
import ErrorPage from './ErrorPage'
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import heroImg from '../Images/sellers-breadcrumb.webp'
import Services from "../Components/Services";
import HomeBlogs from "../Components/HomeBlogs";
import Cta from "../Components/Cta";
import BuyersContent from "../Components/BuyersContent";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from '../Schemas/breadcrumbSchema'
import faqSchema from "../Schemas/faqSchema";

const Sellers=()=>{
     const { slug } = useParams();

  const seller = sellers.find(item => item.slug === slug);

  useEffect(() => {
      if (!seller) return;
      document.title = `${seller.metaTitle}`;

      const metaDesc = document.querySelector(
        "meta[name='description']"
      );
      if (metaDesc) {
        metaDesc.setAttribute("content", seller.metaDesc);
      }

        let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://ldlsettlementservices.com.au/sellers/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      seller.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      seller.metaDesc
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://ldlsettlementservices.com.au/sellers/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://ldlsettlementservices.com.au/Images/seller-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
     seller.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
    seller.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://ldlsettlementservices.com.au/Images/seller-img.webp"
    );
  }

    }, [seller, slug]);


  if (!seller) {
    return <ErrorPage />;
  }

    const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
  {
    name: seller.title
  }
]);

const sellerFaqs = seller.slug === "faqs"
  ? seller.sections
      .filter((section) => section.type === "faq")
      .map((section) => ({
        question: section.heading,
        answer: [
          ...(section.paragraphs || []),
          ...(section.points || [])
        ].join(" ")
      }))
  : [];

    const faqs = seller.slug === "faqs"
  ? faqSchema(sellerFaqs)
  : null;

    return(
        <>
        <React.Fragment key={slug}>

          <SchemaMarkup schema={breadcrumbs} />
          {faqs && <SchemaMarkup schema={faqs} />}


        {/**HEADER */}
           <Header
        showBreadcrumb={true}
         breadcrumbItems={[
    {
      label: "Sellers",
    },
    {
      label: seller.title,
    },
  ]}
      />

      {/**HERO SECTION */}
      <BreadcrumbMain
      subTitle="FOR SELLERS"
      title="The Complete Property Seller’s Guide"
      specialNote="Your Step-by-Step Settlement Resource"
      description="Everything you need to know about selling property in Western Australia. Explore step-by-step settlement guides, calculate your selling costs, access specialized advice on preparing your property for handover, and use our practical checklists to guarantee a stress-free settlement day."
      image={heroImg}
      showIcons={false}
    />

    {/**CONTENT SECTION */}
    <BuyersContent
        sidebarTitle={
          seller.sidebarTitle
        }
        type="sellers"
        sidebarLinks={sellers}
        currentSlug={
          seller.slug
        }
        contentHeading={
          seller.contentHeading
        }
        intro={
          seller.intro
        }
        sections={
          seller.sections
        }
      />

    {/**SERVICE CARDS SECTION */}
    <section className="buyers-pg">
     <Services/>
     </section>

       {/**BLOGS GRID */}
    <HomeBlogs />

     {/**CTA SECTION */}
          <Cta/>

        </React.Fragment>
        </>
    )
}
export default Sellers;